import React from 'react';

import { Container } from '@material-ui/core';
import IFrameUI from '../iFrameUI/iFrameUI';
import FileUpload from '../shared/fileUpload/fileUpload';

const Test = () => (
  <div>
    <br />
    <br />
    <br />
    <FileUpload />
    <br />
    <br />
    <Container maxWidth="md">
      <iframe width="700" height="600" allow="local-network-access; geolocation" title="Proyectos eGreen" src="https://egreen.maps.arcgis.com/apps/mapviewer/index.html?configurableview=true&webmap=5d1e8ce3fece4ed2a024db52f41b338a&theme=light&scroll=false&center=-72.81273220018477,-44.29324157541624&scale=72223.819286" ></iframe>
    </Container>
  </div>
);

export default Test;

